import WithModal, { CommonModalPropsI } from "@components/HOC/withModals";
import { MODALS_ENUM } from "@constants/Modals";
import styles from "./AddClient.module.scss";

import origGen from "@assets/redesign/icons/refresh.svg";
import wlpGen from "@components/WLP202603/assets/redesign/icons/refresh.svg";
import Icon from "@components/global/new/Icon/Icon";
import { useAddClientControl } from "./useAddClientControl";
import Error from "@components/global/new/Error/Error";
import { Button } from "antd";
import { Input } from "@components/global/new/Input/Input";
import { Select } from "@components/global/new/Select/Select";
import { UserRole } from "@services/http/responses/AccountResponse";
import { WLP202603 } from "../../../../config";

const gen = WLP202603 ? wlpGen : origGen;

type AddUserParams = CommonModalPropsI & {
  title: string;
  singleRole?: UserRole;
  onRefresh: () => void
};

function AddClient({
  title,
  singleRole,
  handleClose,
  onRefresh,
  formatMessage,
}: AddUserParams) {

  const control = useAddClientControl(() => {
    onRefresh();
    handleClose();
  });

  return (
    <div className={styles.wrapper}>
      <h4>{title}</h4>
      <div className={styles.content}>
        <form className={styles.client} onSubmit={control.onSubmit}>
          <Input
            label={formatMessage({ id: "modal.new_client.email" })}
            name='Email'
            type='email'
            placeholder='example@mail.com'
            id='email'
            copyButton
          />
          <div className={styles.passwordContainer}>
            <Input
              label={formatMessage({ id: "modal.new_client.password" })}
              name={formatMessage({ id: "modal.new_client.password" })}
              type='text'
              placeholder='A(HDF&hidh'
              id='password'
              value={control.generated}
              copyButton
            />
            <div className={styles.random}>
              <Icon src={gen} onClick={control.onGenerate} />
              <span>{formatMessage({ id: "modal.new_client.generate" })}</span>{" "}

            </div>
          </div>
          <Select
            id="role"
            name="role"
            label="Roles"
            options={control.roles}
            disabled={singleRole !== undefined}
            value={singleRole}
          />
          {control.errorField && <Error errors={control.errorField} />}
          <Button htmlType="submit" type="primary">
            {formatMessage({ id: "modal.new_client.save" })}
          </Button>
        </form>
      </div>
    </div>
  );
}

export default WithModal(MODALS_ENUM.ADD_NEW_CLIENT, AddClient);
